import React from "react";
import "./HealthTwoFoodCollection.scss";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useNavigate } from "react-router-dom";

const HealthTwoFoodCollection = () => {
  const navigate = useNavigate();

  const { documents } = useCollection("products", [
    "category",
    "array-contains",
    "Baby Food Collections",
  ]);

  const babyFoodDeals = documents
    ? documents.filter((product) => product.status === "active")
    : [];

  return (
    <div className="health-two-baby-products">
      <div className="deals-header">
        <h2 className="health-two-section-heading">Baby Food Collection</h2>
        <a href="/products-two">SEE ALL PRODUCTS →</a>
      </div>

      <div className="deals-list">
        {babyFoodDeals.map((deal, index) => (
          <div
            className="deal-card"
            key={index}
            onClick={() => navigate(`/product-details-two/${deal.id}`)}
          >
            {deal.offer && <span className="offer-tag">{deal.offer}</span>}
            <img src={deal.images[0]} alt={deal.name} />
            <div className="deal-info">
              <span className="category">{deal.category}</span>
              <h4>{deal.name}</h4>
              {deal.short_description && (
                <p className="short-description">{deal.short_description}</p>
              )}
              <div className="price-and-button">
                <button className="add-btn">+ Add to Cart</button>
                <div className="price-container">
                  <span className="price">₹{deal.price}</span>
                  {deal.originalPrice && (
                    <span className="original-price">
                      ₹{deal.originalPrice}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthTwoFoodCollection;
